/* @flow */

import { useContext, useMemo } from "react";
import { useLocation } from "react-router";
import { StoreInfoContext } from "entrypoint/shared";

const useOnFullMenuHiddenRoute = (): boolean => {
  const { routes, configuration } = useContext(StoreInfoContext);
  const { pathname } = useLocation();

  // Only allow submenu for earnView subpages
  const earnView = ((routes.earnViewSubpage && routes.earnViewSubpage.toggle) ||
  (routes.earnViewSubpage2 && routes.earnViewSubpage2.toggle) ||
  (routes.earnViewSubpage3 && routes.earnViewSubpage3.toggle) ||
  (routes.earnViewSubpage4 && routes.earnViewSubpage4.toggle));

  const shopTermsUrl = (configuration.customShopTermsUrl &&
    configuration.hasCustomShopTermsUrl === true) ?
    configuration.customShopTermsUrl : "checkout-terms";

  const FULL_MENU_HIDDEN_ROUTES = useMemo(() => {
    const routeUrls = [
      routes.accountView?.url,
      routes.alternateContent1?.url,
      routes.alternateContent2?.url,
      routes.alternateContent3?.url,
      routes.currentInfoView1?.url,
      routes.currentInfoView2?.url,
      routes.currentInfoView3?.url,
      routes.currentInfoView4?.url,
      routes.currentInfoView5?.url,
      routes.currentInfoView6?.url,
      routes.currentInfoViewHome?.url,
      routes.calculatorView?.url,
      routes.faqView?.url,
      routes.formListView?.url,
      routes.leadsView?.url,
      routes.leaderboardView?.url,
      routes.newsListView?.url,
      routes.offerListView?.url,
      routes.photoServiceView?.url,
      routes.quizHistory?.url,
      routes.quizList?.url,
      routes.reportsView?.url,
      routes.reportsHistory?.url,
      routes.reportApproval?.url,
      routes.suppliersView?.url,
      routes.teamPot?.url,
      "/about-svea",
      "/about-release",
      "/about-wownyckeln",
      "/about-dreamteam",
      "/privacy-notice",
      "/forms",
      routes.termsView?.url,
      shopTermsUrl,
      earnView === false ? routes.earnView?.url : undefined,
    ];

    return routeUrls.filter(Boolean);
  }, [routes]);

  return FULL_MENU_HIDDEN_ROUTES.some(route => pathname.includes(route));
};

export default useOnFullMenuHiddenRoute;
